// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import Vue from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import App from "./app.vue";
import Vue2Filters from "vue2-filters";
import VueCookies from "vue-cookies";
import router from ".";
import * as config from "./shared/config/config";
import * as bootstrapVueConfig from "./shared/config/config-bootstrap-vue";
import BootstrapVueIcons from "bootstrap-vue";

import "../content/scss/vendor.scss";
import TranslationService from "@/shared/services/translation.service";

/* tslint:disable */
import GlobalService from "@/shared/services/global.service";

// ODO
import ESGGameService from "@/products/esg/services/esg-game.service";

import Game360Service from "./products/360/services/game-360.service";

import ModulableGameService from "@/products/modulable/modulable-game.service";
import ClientService from "./shared/services/client.service";

// Charts
import VueApexCharts from "vue-apexcharts";

//Slider
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
Vue.component("VueSlider", VueSlider);

/* tslint:enable */
Vue.config.productionTip = false;
config.initVueApp(Vue);
config.initFortAwesome(Vue);
bootstrapVueConfig.initBootstrapVue(Vue);
Vue.use(BootstrapVueIcons);

Vue.use(Vue2Filters);
Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.component("apexchart", VueApexCharts);

import VueRecaptcha from "vue-recaptcha";
import CompanyService from "./shared/services/parameter.service";
import ParameterService from "./shared/services/parameter.service";

Vue.component("vue-recaptcha", VueRecaptcha);
const i18n = config.initI18N(Vue);
i18n.locale = "fr";
const store = config.initVueXStore(Vue);

const translationService = new TranslationService(store, i18n);

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next("/core/not-found");
  }

  // garde le path de coté
  sessionStorage.setItem("path", to.fullPath);

  next();
});

Vue.use(VueCookies);

/* tslint:disable */
new Vue({
  el: "#app",
  components: { App },
  template: "<App/>",
  router,
  provide: {
    translationService: () => translationService,
    clientService: () => new ClientService(),
    esgGameService: () => new ESGGameService(),
    globalService: () => new GlobalService(),
    game360Service: () => new Game360Service(),
    modulableGameService: () => new ModulableGameService(),
    parameterService: () => new ParameterService(),
    companyService: () => new CompanyService(),
  },
  i18n,
  store,
});
